<template lang="pug">
Card.card.estimation
    template(#title) {{ $t('estimatedCosts.title') }}
    template(#content)
        .estimated-costs(v-if="report != undefined")
            .estimated-costs-row
                div.title {{ $t('estimatedCosts.totalMeasureCost') }}
                div.amount.amount-value {{ formatNumberToString(report.totalMeasureCost) }}
            .estimated-costs-row
                div.title {{ $t('estimatedCosts.totalGrantCost') }}
                div.amount.amount-value.success — {{ formatNumberToString(report.totalGrantCost) }}
            .estimated-costs-row(v-if="settings.recommendationsPageOptions?.showDiscount")
                div.title {{ $t('estimatedCosts.totalDiscountCost') }}
                div.amount.amount-value.success — {{ formatNumberToString(report.totalDiscountCost) }}
            .estimated-costs-row.border-cost
                div.title.bold {{ $t('estimatedCosts.estimatedTotalCost') }}
                div.amount.amount-value.m {{ formatNumberToString(report.estimatedTotalCost) }}
            .estimated-costs-row(v-if="selectedLoan.name && selectedLoan.name !== 'No loan'")
                div.title.bold {{ $t('estimatedCosts.estimatedTotalCost') + netCostInterestTitle }}
                div.amount.amount-value.l {{ formatNumberToString(report.estimatedTotalCostPlusLoanInterest) }}
            .estiamted-costs-row 
                div.subtitle {{ $t('estimatedCosts.vat') }}
            .estimated-costs-row.grant-msg(v-if="grantMessages.length > 0")
                div.amount(@click="showGrantDialog()")
                  span.info.pi.pi-info-circle
                  span(v-safe-html="$t('estimatedCosts.grant')")
</template>
<script lang="ts">
import {
  formatNumberToString,
  formatPercentageToString,
  emit,
  LayoutEvent,
} from "@/helpers";
import { useLoan, useSettings } from "@/store";
import { useRecommendations } from "@/store/recommendations";
import { computed, defineComponent } from "vue";
import { storeToRefs } from "pinia";
import Card from "primevue/card";
import { LoanType } from "@/types";
export default defineComponent({
  name: "EstimatedCostsCard",
  components: {
    Card,
  },
  setup() {
    const { report, grantMessages } = storeToRefs(useRecommendations());
    const { selectedLoan, selectedLoanOption, paymentBand } = storeToRefs(
      useLoan()
    );
    const { settings } = storeToRefs(useSettings());

    const netCostInterestTitle = computed(() =>
      paymentBand.value ||
      selectedLoanOption.value?.loanType === LoanType.Mortgage
        ? paymentBand.value?.fixedFee
          ? ` (Including interest at ${formatPercentageToString(
              paymentBand.value.apr
            )} and ${formatNumberToString(
              paymentBand.value?.fixedFee
            )} fixed fee)`
          : ` (Including interest)`
        : ""
    );

    function showGrantDialog() {
      emit(LayoutEvent.ShowGrantDialog, true);
    }

    return {
      report,
      selectedLoan,
      formatNumberToString,
      netCostInterestTitle,
      grantMessages,
      showGrantDialog,
      settings,
    };
  },
});
</script>
<style scoped lang="scss">
.estimation {
  cursor: default;
  .rating-img {
    height: 292px;
    width: 288px;
  }
  .estimated-costs-row {
    display: flex;
    justify-content: space-between;
    padding: 5px;
  }
  .border-cost {
    padding: 10px 5px;
    margin: 10px 0;
  }
  .subtitle {
    padding: 5px;
  }
  .bold {
    font-weight: bold;
  }
  .success {
    color: $success-color;
  }
  .grant-msg {
    justify-content: flex-end;
    cursor: pointer;
    margin-top: 0.75rem;
    .pi {
      margin-right: 0.5rem;
    }
    :deep(a) {
      text-decoration: underline;
      color: $secondary-color;
    }
  }
}
</style>
